import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { TrendingUpIcon, ShieldCheckIcon, ClockIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 overflow-hidden" data-id="element-118">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-119">
        <div className="absolute inset-0 bg-trading-dark/80 bg-gradient-to-b from-trading-dark/60 via-trading-dark/80 to-trading-dark z-10" data-id="element-120" />
        <img src="https://cdn.magicpatterns.com/uploads/v1kjfAnwyDSSiZFnFNpvqn/heylloyd-image-1773112641959.png" alt="Trading Setup" className="w-full h-full object-cover object-center opacity-40" data-id="element-121" />
      </div>

      <div className="container mx-auto px-4 relative z-20" data-id="element-122">
        <div className="max-w-4xl mx-auto text-center" data-id="element-123">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7
        }} data-id="element-124">
            <span className="inline-block py-1 px-3 rounded-full bg-trading-gold/10 border border-trading-gold/30 text-trading-amber text-sm font-bold tracking-wider mb-6 uppercase" data-id="element-125">
              El Protocolo de 15 Minutos
            </span>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-heading font-bold mb-6 leading-tight" data-id="element-126">
              Deja de "Donar" Dinero a las{' '}
              <span className="text-gradient-gold" data-id="element-127">Empresas de Fondeo</span>
            </h1>

            <p className="text-xl md:text-2xl text-slate-300 mb-10 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-128">
              Pasa tus Fases 1 y 2 sin arriesgar tu salud mental, operando solo
              la apertura de Nueva York y eliminando el 90% del ruido del
              mercado.
            </p>

            <div className="flex flex-col items-center justify-center gap-3 mb-12" data-id="element-129">
              <div className="bg-trading-gold/10 border border-trading-gold/30 rounded-lg px-5 py-3 text-center" data-id="element-130">
                <p className="text-trading-amber font-heading font-bold text-sm uppercase tracking-wider" data-id="element-131">
                  🔥 Aprovecha la oferta por tiempo limitado
                </p>
                <p className="text-white text-lg mt-1" data-id="element-132">
                  <span className="text-slate-400 line-through text-sm mr-2" data-id="element-133">
                    $45 USD
                  </span>
                  <span className="text-trading-gold font-heading font-bold text-2xl" data-id="element-134">
                    $9.99 USD
                  </span>
                </p>
              </div>
              <Button href="https://impactoproactivo.com/cart/40925420453952:1" className="w-full sm:w-auto text-xl py-5 px-10 shadow-[0_0_30px_rgba(212,168,67,0.3)]" data-id="element-135">
                ¡QUIERO MI ESTRATEGIA PARA PASAR CUENTAS AHORA!
              </Button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto text-left" data-id="element-136">
              <div className="flex items-center gap-3 bg-white/5 backdrop-blur-sm p-4 rounded-lg border border-white/10" data-id="element-137">
                <ClockIcon className="text-trading-gold w-8 h-8 flex-shrink-0" data-id="element-138" />
                <div data-id="element-139">
                  <p className="font-bold text-white text-sm" data-id="element-140">
                    15 Minutos al Día
                  </p>
                  <p className="text-xs text-slate-400" data-id="element-141">Sin sobre-operar</p>
                </div>
              </div>
              <div className="flex items-center gap-3 bg-white/5 backdrop-blur-sm p-4 rounded-lg border border-white/10" data-id="element-142">
                <ShieldCheckIcon className="text-trading-gold w-8 h-8 flex-shrink-0" data-id="element-143" />
                <div data-id="element-144">
                  <p className="font-bold text-white text-sm" data-id="element-145">
                    Riesgo Controlado
                  </p>
                  <p className="text-xs text-slate-400" data-id="element-146">Protege tu Drawdown</p>
                </div>
              </div>
              <div className="flex items-center gap-3 bg-white/5 backdrop-blur-sm p-4 rounded-lg border border-white/10" data-id="element-147">
                <TrendingUpIcon className="text-trading-gold w-8 h-8 flex-shrink-0" data-id="element-148" />
                <div data-id="element-149">
                  <p className="font-bold text-white text-sm" data-id="element-150">Alta Precisión</p>
                  <p className="text-xs text-slate-400" data-id="element-151">Setup Institucional</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-trading-dark to-transparent z-10" data-id="element-152" />
    </section>;
}